module.exports = __webpack_public_path__ + "3af6cc411f5ef6c15c2cfe12e6644849.svg";